(function($) {
  $.validator.addMethod('minMonth', function(value, element) {
    var currentDate = new Date();
    var result = false;

    if (parseInt($('#cardExpirationYear').val(), 10) > currentDate.getFullYear()) {
      result = true;
    } else if (parseInt(value, 10) >= (currentDate.getMonth() + 1)) {
      result = true;
    }

    return result;
  }, 'Data de validade inválida.');

  $.validator.addMethod('minYear', function(value, element) {
    var currentDate = new Date();
    return parseInt(value, 10) >= currentDate.getFullYear();
  }, 'Data de validade inválida.');
}(jQuery));



// WEBPACK FOOTER //
// ./src/js/vendor/jquery.validate.custom.js